import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
import { useContext } from 'react';
import IconButton from '@mui/material/IconButton';
import { X } from 'react-feather';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { CONSTANTS } from '../../../constants/constants';
import { FiltersContext } from '../../../pages/NRReportTabs/NRReportFilterContextWrapper';
import { styled } from '@mui/material/styles';
export const DRAWER_WIDTH = '650px';

const { CLOSE } = CONSTANTS.ACTIONS;

export const DrawerMainContainer = styled(Box)(() => ({ height: '100%', display: 'flex', flexDirection: 'column' }));

const DrawerHeaderWrapper = styled(Box)(({ theme }) => ({
  height: theme.spacing(8),
  borderBottom: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2, 3)
}));

export const DrawerHeader = ({ drawerTitle, drawerTitleExtraComponents, handleClose }) => {
  return (
    <DrawerHeaderWrapper>
      <Typography variant="h3" component="div" mt={0.5}>
        {drawerTitle}
      </Typography>
      {drawerTitleExtraComponents}
      <IconButton aria-label="Close" onClick={handleClose} size="small">
        <X fontSize={12} />
      </IconButton>
    </DrawerHeaderWrapper>
  );
};

export const DrawerContent = styled(Box)(({ theme }) => ({ height: '100%', maxHeight: `calc(100vh - ${theme.spacing(16)})`, overflowY: 'auto' }));

const DrawerFooterWrapper = styled(Box)(({ theme }) => ({
  height: theme.spacing(8),
  padding: theme.spacing(1, 3),
  display: 'flex',
  alignItems: 'center',
  borderTop: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  zIndex: 1
}));

export const DrawerFooter = ({ hasBack, handleBack, handleClose }) => {
  return (
    <DrawerFooterWrapper>
      {hasBack && (
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleBack}
          data-testid={'cancel-footer-button-drawer'}
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <ArrowBackIcon style={{ fontSize: 18, marginTop: -2 }} />
          <Box component="span" sx={{ lineHeight: 1.75 }}>
            Back
          </Box>
        </Button>
      )}
      <Button sx={{ marginLeft: 'auto' }} variant="contained" color="secondary" onClick={handleClose} data-testid={'cancel-footer-button-drawer'}>
        {CLOSE}
      </Button>
    </DrawerFooterWrapper>
  );
};

function NRClickThroughDrawer() {
  const {
    openDrawer,
    setOpenDrawer,
    drawerContent,
    drawerTitle,
    setDrawerTitle,
    hasBack,
    setDrawerContent,
    setHasBack,
    drawerTitleExtraComponents,
    setDrawerTitleExtraComponents
  } = useContext(FiltersContext);

  const handleBack = () => {
    setHasBack(drawerTitle.length - 1 > 1);
    setDrawerTitle(drawerTitle.slice(0, -1));
    setDrawerContent(drawerContent.slice(0, -1));
  };

  const handleClose = () => {
    setHasBack(false);
    setOpenDrawer(false);
    setDrawerContent([]);
    setDrawerTitleExtraComponents(null);
    setDrawerTitle([]);
  };
  return (
    <Drawer
      PaperProps={{ sx: { width: DRAWER_WIDTH } }}
      anchor={'right'}
      open={openDrawer}
      variant={'temporary'}
      onClose={() => handleClose()}
      onKeyDown={event => {
        if (event.key === 'Escape') {
          handleClose();
        }
      }}
    >
      <DrawerMainContainer>
        <DrawerHeader
          drawerTitle={!!drawerTitle && !!drawerTitle.length ? drawerTitle.at(-1) : ''}
          drawerTitleExtraComponents={drawerTitleExtraComponents}
          handleClose={handleClose}
        />
        <DrawerContent>{!!drawerContent && !!drawerContent.length && drawerContent[drawerContent.length - 1]}</DrawerContent>
        <DrawerFooter hasBack={hasBack} handleBack={handleBack} handleClose={handleClose} />
      </DrawerMainContainer>
    </Drawer>
  );
}

export default NRClickThroughDrawer;
